import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  EventEmitter,
  Output,

} from '@angular/core';

import { FnDateFormatter } from '../../util/date';
import { NgbDate, NgbDateParserFormatter, NgbDatepicker, NgbDateStruct, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { FnDateTimeModel } from './fn-date-time-picker.model';

@Component({
  selector: 'fn-date-time-picker',
  templateUrl: './fn-date-time-picker.component.html',
  providers: [FnDateFormatter],
  encapsulation: ViewEncapsulation.None,
})
export class FNDateTimePickerComponent implements OnInit {

  @Input() time: Date;
  @Input() minDate: Date;
  @Input() disabled = false;
  @Input() appendTo = '';
  @Input() dateFormat = "m/d/Y H:i:s";
  @Input() showTimePickerToggle = false;
  @Input() hourStep = 1;
  @Input() minuteStep = 1;
  @Input() secondStep = 1;
  @Input() seconds = true;
  @Output() callback = new EventEmitter<Date>();
   
  minDisableDate = new FnDateTimeModel()
  datetime = new FnDateTimeModel();
  uitime: string;

  constructor(public formatter: NgbDateParserFormatter) {

  }

  ngOnInit(): void {
    this.time = this.time || new Date();
    this.minDisableDate.setDetails(this.minDate)
    this.datetime.setDetails(this.time);
    this.uitime = this.time.formatter(this.dateFormat);
  }

  onDateChange(event: NgbDateStruct) {
    this.datetime.year = event.year;
    this.datetime.month = event.month;
    this.datetime.day = event.day;
    this.setDateStringModel();
  }

  getDateClass(date: NgbDate) {
    let customClass = 'custom-day ';
    if (date.equals(this.datetime)) {
      customClass += 'range';
    }
    return customClass;
  }

  toggleDateTimeState(event: Event) {
    this.showTimePickerToggle = !this.showTimePickerToggle;
    event.stopPropagation();
  }

  onTimeChange(event: NgbTimeStruct) {
    this.datetime.hour = event.hour;
    this.datetime.minute = event.minute;
    this.datetime.second = event.second;
    this.setDateStringModel();
  }

  setDateStringModel() {
    this.time = this.datetime.getDate();
    this.callback.emit(this.time);
    this.uitime = this.time.formatter(this.dateFormat);
  }

  isDisabledDate = (date: NgbDateStruct): boolean => {
    return this.minDate ?
      (new Date (this.formatter.format(date)) < new Date (this.formatter.format(this.minDisableDate))) : false;
  };

}
